import { importClassOnScroll } from "../../utilities/dynamicImportsUtility";

class HomepageSearchValetWidget {
  public constructor() {
    this.loadWidgetOnScroll();
  }

  private loadWidgetOnScroll() {
    const widgetElement = document.querySelector(
      ".opensearch-widget-container"
    );

    if (widgetElement) {
      importClassOnScroll(
        () =>
          import(
            /* webpackChunkName: "homepageSearchValet" */ `../../components/homepageSearchWidget/searchValet/homepageSearchValet`
          ),
        widgetElement,
        true
      );
    }
  }
}

new HomepageSearchValetWidget();
